export default "__VITE_ASSET__DcVfySyg__"